import React from 'react';
import { useTeam } from '../context/TeamContext';
import ManagerView from '../components/Teams/ManagerView';
import DirectorView from '../components/Teams/DirectorView';
import AVPView from '../components/Teams/AVPView';
import Card from '../components/Common/Card';

const TeamHierarchyPage = () => {
  const { userRole, switchRole } = useTeam();

  const roleOptions = [
    { value: 'manager', label: '👤 Manager', description: 'Create teams and assign activities' },
    { value: 'director', label: '📊 Director', description: 'View manager teams and their FTE requirements' },
    { value: 'avp', label: '🏢 Associate VP', description: 'Executive rollup view with condensed data' }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header with Role Selector */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Team Hierarchy & FTE Management</h1>
          <p className="text-gray-600 mb-6">
            Manage organizational structure and break down FTE requirements by team
          </p>

          {/* Role Selector */}
          <Card title="Select Your View">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {roleOptions.map(option => (
                <button
                  key={option.value}
                  onClick={() => switchRole(option.value)}
                  className={`p-4 border-2 rounded-lg transition-all text-left ${
                    userRole === option.value
                      ? 'border-blue-500 bg-blue-50'
                      : 'border-gray-200 hover:border-blue-300 bg-white'
                  }`}
                >
                  <div className="text-lg font-semibold mb-1">{option.label}</div>
                  <div className="text-sm text-gray-600">{option.description}</div>
                  {userRole === option.value && (
                    <div className="mt-2">
                      <span className="text-xs bg-blue-600 text-white px-2 py-1 rounded">Active</span>
                    </div>
                  )}
                </button>
              ))}
            </div>
          </Card>
        </div>

        {/* Role-based View */}
        <div>
          {userRole === 'manager' && <ManagerView />}
          {userRole === 'director' && <DirectorView />}
          {userRole === 'avp' && <AVPView />}
        </div>
      </div>
    </div>
  );
};

export default TeamHierarchyPage;
